import styled from 'styled-components';
import DataTable from '@components/DataTable';

export const ChartDataTable = styled(DataTable)`
  caption {
    padding-left: 0;
    padding-bottom: 0;
    text-align: left;
  }

  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
    vertical-align: middle;
  }

  tbody tr {
    ${({ theme }) => theme.typography.tiny};
  }

  tr {
    height: ${({ theme }) => theme.x4spacePx}px;
  }
`;
